<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Usuarios</h5>
        </div>
        <emt-form ref="user-form" v-bind:resource="itemresource" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="user-grid" v-bind:resource="config.api + '/user_full_data/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-register-user'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default {
    name: 'emt-form-user',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'username',
                    'label': 'Usuario',
                    'placeholder': 'Ingrese nombre de usuario',
                    'value': null,
                    'maxlength': '30',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'password',
                    'label': 'Contraseña',
                    'placeholder': 'Ingrese contraseña',
                    'value': null,
                    'maxlength': '128',
                    'type': 'password',
                    'errors': []
                }, {
                    'name': 'first_name',
                    'label': 'Nombres',
                    'value': null,
                    'placeholder': 'Ingrese nombres',
                    'maxlength': '30',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'last_name',
                    'label': 'Apellidos',
                    'value': null,
                    'placeholder': 'Ingrese apellidos',
                    'maxlength': '30',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'email',
                    'label': 'Correo electrónico principal',
                    'value': null,
                    'placeholder': 'Ingrese correo electrónico principal',
                    'maxlength': '254',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'email_alternative',
                    'label': 'Correo electrónico alternativo',
                    'value': null,
                    'placeholder': 'Ingrese correo electrónico alternativo',
                    'maxlength': '200',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'group',
                    'label': 'Perfil',
                    'placeholder': 'Seleccione un perfil',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'visible': false
                }, {
                    'name': 'company',
                    'label': 'Empresa o filial',
                    'placeholder': 'Seleccione una empresa o filial',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'visible': false
                }
            ],
            itemsGrid: [
                {
                    'name': 'username',
                    'label': 'Usuario',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'first_name',
                    'label': 'Nombres',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'last_name',
                    'label': 'Apellidos',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'email',
                    'label': 'Correo electrónico',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'groups',
                        'key': 'name'
                    },
                    'label': 'Perfil',
                    'ordering': true
                }, {
                    'name': 'is_active',
                    'label': 'Activo',
                    'ordering': true,
                    'filters': ['exact'],
                    'filterList': Config.statusList
                }
            ],
            itemresource: [
                {
                    'resourceUser': '/user/',
                    'resourcePerfil': '/group/'
                }
            ],
            config: Config,
            update: false,
            editUrl: '/User/',
            deleteUrl: Config.api + '/user/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['user-grid'].reload()
        },
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[7].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        getGroup: function () {
            var self = this
            self.$http.get(Config.api + '/group/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[6].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        getCompany: function () {
            var self = this
            self.$http.get(Config.api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[8].select_options.push({
                        value: response.body[data].id,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getGroup()
        this.getUnits()
        this.getCompany()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-user.vue?066bfb4b